// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.has-switch .switch-on label {
  background-color: #fff;
  color: #000;
}

.make-switch {
  z-index: 2;
}

.iq-card {
  padding: 15px;
}

.p1 {
  font-size: 12px;
}

.react-calendar {
  width: 100%;
}

.black {
  color: #000;
  background: #f2f5fa;
  padding: 20px 20px;
  border-radius: 0px 4px 4px 0px;
}

#categorytbl {
  width: 100%;
}

.black:hover {
  background: #fff;
  padding: 20px 20px;
  color: rgba(66, 149, 210, 1);
}

.code_editor {
  min-height: 300px;
}

.has-switch .switch-on label {
  background-color: #fff;
  color: #000;
}

.make-switch {
  z-index: 2;
}

.home {
  margin: 2px 10px;
}

.switch {
  margin: 0px 4px;
}

label {
  font-size: 18px;
}

a {
  color: #000;
}

.table thead th {
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  color: #161616;
  /* border-bottom: 2px solid var(--iq-body-bg); */
}

.table thead th {
  /* vertical-align: bottom; */
  border-bottom: 2px solid #dee2e6;
}

.table-bordered thead td,
.table-bordered thead th {
  border-bottom-width: 2px;
}

.table thead th {
  /* vertical-align: bottom; */
  border-bottom: 2px solid #dee2e6;
}

.table-bordered td,
.table-bordered th {
  /* border: 1px solid var(--iq-body-bg); */
  padding: 10px;
}

.table td,
.table th {
  vertical-align: middle;
}

.table-bordered td,
.table-bordered th {
  border: 1px solid #dee2e6;
}

.table td,
.table th {
  /* padding: 0.75rem; */
  vertical-align: top;
  /* border-top: 1px solid #dee2e6; */
}

.table-bordered td,
.table-bordered th {
  border: 1px solid #dee2e6;
}

.table td,
.table th {
  /* padding: 0.75rem; */
  vertical-align: middle;
  /* border-top: 1px solid #dee2e6; */
}

.headingpop {
  display: table-caption;
}

.home_mobile .nav-tabs {
  border-bottom: 2px solid rgba(255, 255, 255, 0.1);
  gap: 10px;
  padding-bottom: 5px;
}

.home_mobile .nav-link {
  background: rgba(255, 255, 255, 0.05);
  font-size: 14px;
  font-weight: 500;
  color: #6c757d;
  border: 1px solid transparent;
  padding: 12px 25px;
  border-radius: 8px 8px 0 0;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.home_mobile .nav-link h6 {
  margin-bottom: 0;
  font-size: 14px;
  font-weight: 600;
}

.home_mobile .nav-link:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #006aff;
  border-color: rgba(255, 255, 255, 0.1);
}

.home_mobile .nav-link.active {
  background: rgba(0, 106, 255, 0.1);
  color: #006aff !important;
  border-bottom: 2px solid #006aff !important;
  font-weight: 700;
  border-radius: 8px 8px 0 0;
  padding: 12px 30px;
}

.nav-tabs .nav-link:hover {
  border-color: transparent;
  isolation: isolate;
}

.nav-tabs {
  border-bottom: none;
}
.paginate-settings {
  margin: 20px;
}

.paginate-value {
  display: flex;
  gap: 40px; 
}

.paginate-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.paginate-label,
.valuebox_label {
  font-size: 16px;
  margin-bottom: 5px;
  font-weight: bold;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Site/Settings/HomePageSettings.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gDAAgD;AAClD;;AAEA;EACE,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;;EAEE,yCAAyC;EACzC,aAAa;AACf;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,sBAAsB;EACtB,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,sBAAsB;EACtB,sBAAsB;EACtB,mCAAmC;AACrC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iDAAiD;EACjD,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,6BAA6B;EAC7B,kBAAkB;EAClB,0BAA0B;EAC1B,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,2CAA2C;EAC3C,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;;EAEE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB","sourcesContent":[".has-switch .switch-on label {\n  background-color: #fff;\n  color: #000;\n}\n\n.make-switch {\n  z-index: 2;\n}\n\n.iq-card {\n  padding: 15px;\n}\n\n.p1 {\n  font-size: 12px;\n}\n\n.react-calendar {\n  width: 100%;\n}\n\n.black {\n  color: #000;\n  background: #f2f5fa;\n  padding: 20px 20px;\n  border-radius: 0px 4px 4px 0px;\n}\n\n#categorytbl {\n  width: 100%;\n}\n\n.black:hover {\n  background: #fff;\n  padding: 20px 20px;\n  color: rgba(66, 149, 210, 1);\n}\n\n.code_editor {\n  min-height: 300px;\n}\n\n.has-switch .switch-on label {\n  background-color: #fff;\n  color: #000;\n}\n\n.make-switch {\n  z-index: 2;\n}\n\n.home {\n  margin: 2px 10px;\n}\n\n.switch {\n  margin: 0px 4px;\n}\n\nlabel {\n  font-size: 18px;\n}\n\na {\n  color: #000;\n}\n\n.table thead th {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 22px;\n  color: #161616;\n  /* border-bottom: 2px solid var(--iq-body-bg); */\n}\n\n.table thead th {\n  /* vertical-align: bottom; */\n  border-bottom: 2px solid #dee2e6;\n}\n\n.table-bordered thead td,\n.table-bordered thead th {\n  border-bottom-width: 2px;\n}\n\n.table thead th {\n  /* vertical-align: bottom; */\n  border-bottom: 2px solid #dee2e6;\n}\n\n.table-bordered td,\n.table-bordered th {\n  /* border: 1px solid var(--iq-body-bg); */\n  padding: 10px;\n}\n\n.table td,\n.table th {\n  vertical-align: middle;\n}\n\n.table-bordered td,\n.table-bordered th {\n  border: 1px solid #dee2e6;\n}\n\n.table td,\n.table th {\n  /* padding: 0.75rem; */\n  vertical-align: top;\n  /* border-top: 1px solid #dee2e6; */\n}\n\n.table-bordered td,\n.table-bordered th {\n  border: 1px solid #dee2e6;\n}\n\n.table td,\n.table th {\n  /* padding: 0.75rem; */\n  vertical-align: middle;\n  /* border-top: 1px solid #dee2e6; */\n}\n\n.headingpop {\n  display: table-caption;\n}\n\n.home_mobile .nav-tabs {\n  border-bottom: 2px solid rgba(255, 255, 255, 0.1);\n  gap: 10px;\n  padding-bottom: 5px;\n}\n\n.home_mobile .nav-link {\n  background: rgba(255, 255, 255, 0.05);\n  font-size: 14px;\n  font-weight: 500;\n  color: #6c757d;\n  border: 1px solid transparent;\n  padding: 12px 25px;\n  border-radius: 8px 8px 0 0;\n  transition: all 0.3s ease;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.home_mobile .nav-link h6 {\n  margin-bottom: 0;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.home_mobile .nav-link:hover {\n  background: rgba(255, 255, 255, 0.1);\n  color: #006aff;\n  border-color: rgba(255, 255, 255, 0.1);\n}\n\n.home_mobile .nav-link.active {\n  background: rgba(0, 106, 255, 0.1);\n  color: #006aff !important;\n  border-bottom: 2px solid #006aff !important;\n  font-weight: 700;\n  border-radius: 8px 8px 0 0;\n  padding: 12px 30px;\n}\n\n.nav-tabs .nav-link:hover {\n  border-color: transparent;\n  isolation: isolate;\n}\n\n.nav-tabs {\n  border-bottom: none;\n}\n.paginate-settings {\n  margin: 20px;\n}\n\n.paginate-value {\n  display: flex;\n  gap: 40px; \n}\n\n.paginate-container {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.paginate-label,\n.valuebox_label {\n  font-size: 16px;\n  margin-bottom: 5px;\n  font-weight: bold;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
